import { useApp } from '../contexts/AppContext';

export default function SessionWarning() {
  const { sessionExpiringSoon, sessionTimeRemaining, extendUserSession, logout } = useApp();

  if (!sessionExpiringSoon) return null;

  const minutes = Math.ceil(sessionTimeRemaining / 60000);

  return (
    <div className="fixed bottom-4 right-4 z-50 bg-amber-50 border border-amber-300 rounded-lg shadow-lg p-4 max-w-sm">
      <p className="text-sm font-medium text-amber-800">Session expiring soon</p>
      <p className="text-xs text-amber-600 mt-1">
        Your session will expire in {minutes} minute{minutes !== 1 ? 's' : ''}.
      </p>
      <div className="flex gap-2 mt-3">
        <button
          onClick={extendUserSession}
          className="px-3 py-1.5 bg-eep-navy text-white text-xs rounded hover:bg-eep-navy-light transition-colors"
        >
          Stay signed in
        </button>
        <button
          onClick={logout}
          className="px-3 py-1.5 bg-gray-200 text-gray-700 text-xs rounded hover:bg-gray-300 transition-colors"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
